import Abstract from "../../abstract-view/abstract.js";

export default class BreadcrumbsItem extends Abstract {
  constructor(element) {
    super();

    this._element = element;
  }

  getFullWidth() {
    const styles = window.getComputedStyle(this._element);

    return this._element.offsetWidth + parseFloat(styles.marginLeft) + parseFloat(styles.marginRight) + parseFloat(styles.borderLeftWidth) + parseFloat(styles.borderRightWidth);
  }
}
